import React from 'react';
import { useQuery } from '@apollo/client';
import QUERY_LAST_COMMANDE from 'graphql/query/commande/getLastEleveCommande.query';
import { MY_ID } from 'helpers/user/authorization';
import { LoadingLayout } from 'components/molecules/Loaders/LoadingLayout';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import { GetLastEleveCommandeQuery } from 'graphql/generated/graphql';
import { CommandeErrorMessageView } from './CommandeErrorMessage.view';
import { getCommandeDefWithEleveFromQuery } from '../../../../helpers/transformApiResponse/commande';

interface CommandeErrorMessageProps {
  error: { message: string };
}

export const CommandeErrorMessage = ({ error }: CommandeErrorMessageProps) => {
  const { data, loading, error: graphqlError } = useQuery<
    GetLastEleveCommandeQuery
  >(QUERY_LAST_COMMANDE, {
    variables: { id: MY_ID }
  });
  if (loading) return <LoadingLayout />;
  if (graphqlError) return <ErrorContainer text={error.message} />;

  const commandes = data.usersPermissionsUser.data.attributes.commandes.data.map(
    c => getCommandeDefWithEleveFromQuery(c)
  );

  return <CommandeErrorMessageView commandes={commandes} />;
};
